<template>
  <div>
    <div class="member-main-tab">
      <ul class="main-tab">
        <li class="active">课程问题</li>
      </ul>
      <a href="javascript:history.go(-1);" class="go-back">
        <div><Icon type="ios-arrow-dropleft" size="20" />返回</div>
      </a>
    </div>

    <div class="member-main-body">
      <div class="main-header"></div>
      <div class="main-table scroll-top">
        <table>
          <thead>
            <tr>
              <th>问题</th>
              <th style="width: 160px">时间</th>
              <th class="center" style="width: 80px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataList" :key="index">
              <td>
                <p class="color2">
                  {{ item.qUserName }}[{{ item.mobile }}] {{ item.agencyName }}
                </p>
                <p v-latex="item.qContent.replace(/(\\n)|\r?\n|\r/g, '<br/>')"></p>
              </td>
              <td>{{ item.qTime }}</td>
              <td class="center">
                <Button
                  v-if="item.exerId > 0"
                  type="primary"
                  :to="{
                    name: 'QuestionDetail',
                    query: { exerid: item.exerId, qid: item.qId },
                  }"
                  style="width: 70px; height: 28px; line-height: 28px"
                  shape="circle"
                  >回 答</Button
                >
                <Button
                  v-else
                  type="primary"
                  :to="{
                    name: 'QuestionDetail',
                    query: { pptid: item.pptId, qid: item.qId },
                  }"
                  style="width: 70px; height: 28px; line-height: 28px"
                  shape="circle"
                  >回 答</Button
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="page" v-show="totalCount > pageSize">
        <Page
          :total="totalCount"
          :current="pageIndex"
          :page-size="pageSize"
          @on-change="changePage"
          show-elevator
          show-total
        />
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { user } from "../../request";
export default {
  mixins: [siteMixin],
  data() {
    return {
      query: {
        agencyId: -1,
        isResolved: -1, //是否回答
        isReport: 0, //是否待详解
        isComment: 0, //是否有追问
        page: 1,
        courseId: "",
        datetime: "",
        qType: "",
        qid: 0,
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 15,
      totalCount: 0,
    };
  },
  mounted() {
    this.setMetaData("我的答疑");
    if (!this.initParams()) return;
    this.getData();
  },
  methods: {
    initParams() {
      this.query.agencyId =
        this.siteConfig.agencyId > 0 ? this.siteConfig.agencyId : -1;
      let state = this.$route.query.s;
      let courseId = this.$route.query.cid;
      let date = this.$route.query.d;
      let type = this.$route.query.t;
      let qId = this.$route.query.qid;
      if (!courseId && !date && !type && !qId) {
        this.$Message.error("参数错误");
        return false;
      }
      if (typeof state != "undefined") {
        this.query.isResolved = state == 0 ? 0 : 1;
        this.query.isReport = state == 2 ? 1 : 0;
        this.query.isComment = state == 3 ? 1 : 0;
      }
      if (courseId) this.query.courseId = courseId;
      if (date) this.query.datetime = date;
      if (type) this.query.qType = type;
      if (qId) this.query.qid = qId;
      return true;
    },
    getData() {
      user.getQuestionList(this.query).then((res) => {
        console.log("questionList", res);
        if (res.status === 1) {
          this.dataList = res.data.list;
          this.totalCount = res.data.total;
        }
      });
    },
    changePage(page) {
      this.query.page = this.pageIndex = page;
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
@import "../../assets/css/member-main.less";

.go-back {
  color: #0e90d2;
  font-size: 16px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  i {
    vertical-align: -0.2em;
    margin-right: 3px;
  }
}
.page {
  padding: 30px 0;
  text-align: center;
}
</style>